import React from 'react'
import DownloadButton from './DownloadButton'
import ExportRecipesHtmlButton from './ExportRecipesHtmlButton'
import { Label } from '@/components/Label'
import { useAuth } from '@/auth'
import { useTranslation } from 'react-i18next'
import { PageEditHeader } from '@/components/PageEditHeader'

export default function UtilsIndex() {
  const auth = useAuth()
  const { t } = useTranslation()
  const canDownloadDatabases = auth.isAdmin || auth.hasRole('bulk-export')

  return (
    <div>
      <PageEditHeader title={t('utils.title')} />

      <div style={{ paddingTop: '30px' }}>
        {canDownloadDatabases && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Label>{t('utils.exportDatabase')}</Label>
            <DownloadButton />
          </div>
        )}

        <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px' }}>
          <Label>{t('utils.exportRecipesHtml')}</Label>
          <ExportRecipesHtmlButton />
        </div>
      </div>
    </div>
  )
}
